<script setup>
import { computed } from "vue"
import { XCircleIcon } from "@heroicons/vue/16/solid"
import { useFilteredFeedStore } from "../utils/store.js"
import bus from "../utils/eventBus.js";
const store = useFilteredFeedStore()

const props = defineProps({
	taxonomy: { type: String, required: true },
	term: { type: String, required: true },
	label: { type: String, required: true },
})

const isActive = computed(() => store.inFilters(props.term, props.taxonomy))

const toggleFilter = () => {
	store.updateFilters({ taxonomy: props.taxonomy, term: props.term })
	store.fetchItems()
	// bus.emit('go')
}
</script>

<template>
	<button
		@click.prevent="toggleFilter"
		:class="[
			'font-bold transition py-2 px-3 inline-flex gap-3 items-center rounded-full',
			isActive ? 'ring-0 bg-orange text-purple hover:bg-white' : 'hover:opacity-50',
		]"
	>
		<span v-html="label"></span>
		<XCircleIcon v-if="isActive" class="size-6" />
	</button>
</template>
